"use client";

import Headline from "../../../../partials/elements/Headline";
import InitiativeCard from "./InitiativeCard/InitiativeCard";

const Initiative = ({ governmentInitiative }) => {
  return (
    <div className="container mx-auto  px-12">
      <Headline
        text=" Government Initiative"
        extraClass="text-center  text-2xl md:text-4xl pt-24 pb-12"
      />
      <InitiativeCard governmentInitiative={governmentInitiative} />
    </div>
  );
};

export default Initiative;
